var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anonymize-btn"},[_c('span',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:({
      content:
        'Randomized data doesn`t contain critical info, but still useful for analysis',
      placement: 'top',
    }),expression:"{\n      content:\n        'Randomized data doesn`t contain critical info, but still useful for analysis',\n      placement: 'top',\n    }"}],staticClass:"anonymize-btn__icon"},[_vm._v("i")]),_c('SwitchButton',{attrs:{"title":_vm.title},on:{"onChange":(v) => _vm.$emit('onChange', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }